/**
 * Copyright © Veeam Software Group GmbH.
 */

import { FileShareObjectType } from '@veeam-vspc/models/web-controllers';

import { core } from 'core/core-module';
import { transformBaseChartData } from 'views/pages/TrendsPage/helpers';

import type { BaseDataResponse } from 'core/services/transport/interfaces/base-data-response';
import type { LineChartData, TrendData } from '../../../../../interfaces';

const names = [
    { label: 'Backup', type: FileShareObjectType.Backup },
    { label: 'Archive', type: FileShareObjectType.Archive },
];

export class ProtectedFileSharesService {
    static fetchData({ backupServicesType, formatDimension = true, reportingPeriodInfo }): Promise<LineChartData> {
        return core.transportService
            .request('Trends/ProtectedFileShares', {
                ...reportingPeriodInfo,
                backupServicesType,
            })
            .then((resp: BaseDataResponse<TrendData>) => transformBaseChartData(resp.data.trends, reportingPeriodInfo, names, formatDimension));
    }
}
